interface IProps {
  size?: number;
  color?: string;
}

export const StatisticsIcon = ({ size = 23 }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.429 2.571H9v7.715H0V3.857h2.571V0H6.43v2.571ZM5.143 1.286H3.857V9h1.286V1.286Zm1.286 2.571V9h1.285V3.857H6.43ZM2.57 5.143V9H1.286V5.143H2.57Z"
      fill="currentColor"
    />
  </svg>
);
